import cn from 'clsx';

import FacebookMediumIcon from 'components/common/IconsV2/FacebookIcon';
import InstagramMediumIcon from 'components/common/IconsV2/InstagramIcon';
import PinterestMediumIcon from 'components/common/IconsV2/PinterestIcon';
import TwitterMediumIcon from 'components/common/IconsV2/TwitterIcon';
import YouTubeMediumIcon from 'components/common/IconsV2/YouTubeIcon';
import type { FooterSocialIconsProps } from 'components/hf/zappos/FooterSocialIcons/FooterSocialIcons.types';
import { containerClasses, containerNonMobileClasses } from 'components/hf/zappos/FooterSocialIcons/FooterSocialIcons.classes';
import useMartyContext from 'hooks/useMartyContext';
import { stripSpecialCharsDashReplace as strip } from 'helpers/index';
import { trackEvent, trackLegacyEvent } from 'helpers/analytics';
import IconButton from 'components/common/IconButton';

const ICON_SIZE = 24;

const SocialIconMap: Record<string, React.ReactElement> = {
  facebook: <FacebookMediumIcon size={ICON_SIZE} />,
  instagram: <InstagramMediumIcon size={ICON_SIZE} />,
  twitter: <TwitterMediumIcon size={ICON_SIZE} />,
  pinterest: <PinterestMediumIcon size={ICON_SIZE} />,
  youtube: <YouTubeMediumIcon size={ICON_SIZE} />
};

const FooterSocialIcons = (props: FooterSocialIconsProps) => {
  const { className, links, ...forwardProps } = props;
  const { testId } = useMartyContext();

  return (
    <div className={cn(containerClasses, containerNonMobileClasses, className)} {...forwardProps} data-slot-id="social-links">
      {links?.footerMenu.map(({ link, text, gae }) => (
        <IconButton
          key={text}
          label={text}
          href={link}
          target="_blank"
          isExternalLink={true}
          rel="noopener noreferrer"
          size="base"
          variant={'icon'}
          data-test-id={testId(text)}
          onClick={() => {
            trackEvent('TE_FOOTER_SOCIAL', strip(gae || text));
            trackLegacyEvent('Footer', 'Connect-with-us', strip(gae || text));
          }}
        >
          {SocialIconMap[text.toLowerCase()]}
        </IconButton>
      ))}
    </div>
  );
};

FooterSocialIcons.displayName = 'FooterSocialIcons';

export default FooterSocialIcons;
